import {
  BackendErrorWithMessageError,
  HandledErrorResponse,
  type HandleIdentifiedErrorFn,
  I18nProviderInjectionToken as I18nCoreHttpErrorProviderInjectionToken,
} from '@pct-ng/core/error-http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { openOKDialog } from '@pct-ng/feature-message-material';
import { map, of } from 'rxjs';

export const handleIdentifiedError: HandleIdentifiedErrorFn = error => {
  if (error instanceof BackendErrorWithMessageError) {
    const { message, status, headers, response } = error;

    const { errors } = error.backendError;
    const translocoService = inject(TranslocoService);
    const errorName = errors[0].strId;
    const translations = translocoService.getTranslation().get(translocoService.getActiveLang());
    const appTranslationKey = `BACKEND_ERROR.${errorName}`;
    const errorHttpPackageTranslationKey = `${I18nCoreHttpErrorProviderInjectionToken.scope}.BACKEND_ERROR.${errorName}`;
    let translationKey: string | undefined = undefined;

    if (translations !== undefined) {
      const translationsKeys = Object.keys(translations);
      if (translationsKeys.find(key => key.startsWith(appTranslationKey)) !== undefined) {
        // Use app namespace
        translationKey = appTranslationKey;
      } else if (
        translationsKeys.find(key => key.startsWith(errorHttpPackageTranslationKey)) !== undefined
      ) {
        // Use error-http package namespace
        translationKey = errorHttpPackageTranslationKey;
      }
    }
    if (translationKey !== undefined) {
      return openOKDialog({
        title: `${translationKey}.TITLE`,
        message: `${translationKey}.MESSAGE`,
      }).pipe(map(() => new HandledErrorResponse(message, status, response, headers, error)));
    }
  }

  return of(error);
};
